import { cssRule } from 'typestyle';

cssRule('html, body', {
  margin: 0,
  padding: 0,
});
